<div id="go-green" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">

        <h2 class="title">Go Green Initiative</h2>

        <h4 class="mt-3 mb-3" style="color: var(--primary); font-weight:600;">
          “Nurturing Nature for a Sustainable Future”
        </h4>

        <p class="inner-lead">
          Shah Satnam Ji Girls’ College is dedicated to promoting environmental sustainability and fostering a green culture on campus. Our ‘Go Green’ initiative includes various programs and activities aimed at reducing our carbon footprint and creating an eco-friendly environment. We have implemented energy-saving measures, such as the use of LED bulbs and energy-efficient appliances. Our campus is a plastic-free zone, and we encourage students and staff to minimize the use of disposable items. We regularly organize tree plantation drives and cleanliness campaigns to enhance the greenery and maintain the aesthetic beauty of the campus. Our waste management system ensures that waste is segregated and disposed of in an environmentally friendly manner. By engaging the entire college community in our green efforts, we aim to create a sustainable and healthy environment for ourselves and for future generations.
        </p>

        <h5 class="mt-4" style="font-weight:600;">Objectives:</h5>
        <ul class="inner-lead">
          <li>To promote environmental awareness and sustainability among students and staff.</li>
          <li>To reduce the college’s carbon footprint through energy-saving and waste-reduction measures.</li>
          <li>To maintain a green and clean campus through regular plantation and cleanliness drives.</li>
          <li>To implement effective waste management and recycling systems.</li>
        </ul>

        <h5 class="mt-4" style="font-weight:600;">Outcomes:</h5>
        <ul class="inner-lead">
          <li>Enhanced environmental consciousness among the college community.</li>
          <li>Significant reduction in energy consumption and waste generation.</li>
          <li>Improved greenery and aesthetic appeal of the campus.</li>
          <li>Positive contribution to environmental sustainability through green practices.</li>
        </ul>

        <h5 class="mt-4" style="font-weight:600;">The Practice:</h5>
        <ul class="inner-lead">
          <li><strong>Energy Conservation:</strong> Using energy-efficient appliances and solar panels to reduce electricity consumption.</li>
          <li><strong>Waste Management:</strong> Segregating waste at source and ensuring proper disposal and recycling.</li>
          <li><strong>Tree Plantation:</strong> Regularly planting trees and maintaining campus gardens to enhance greenery.</li>
          <li><strong>Plastic-Free Zone:</strong> Prohibiting the use of single-use plastics and promoting eco-friendly alternatives.</li>
        </ul>

        <h5 class="mt-5" style="font-weight:600;">Gallery:</h5>
        <div class="row g-3 mt-2 mb-4">
          <div class="col-12 col-md-4">
            <div class="rounded-4 overflow-hidden shadow-sm border">
              <img src="assets/img/quick-links/go-green/go_green_1-1-1400x630.jpg" alt="Go Green Initiative" class="img-fluid w-100" style="object-fit: cover; height: 220px;">
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="rounded-4 overflow-hidden shadow-sm border">
              <img src="assets/img/quick-links/go-green/go_green_2.jpg" alt="Go Green Initiative" class="img-fluid w-100" style="object-fit: cover; height: 220px;">
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="rounded-4 overflow-hidden shadow-sm border">
              <img src="assets/img/quick-links/go-green/3.jpg" alt="Go Green Initiative" class="img-fluid w-100" style="object-fit: cover; height: 220px;">
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
